const environment = import.meta.env.VUE_APP_MODE === 'production' ? 'production' : 'staging';
export default {
    accessToken: import.meta.env.VUE_APP_ROLLBAR_ACCESS_TOKEN,
    captureUncaught: true,
    captureUnhandledRejections: true,
    enabled: !!import.meta.env.VUE_APP_ROLLBAR_ACCESS_TOKEN,
    environment,
    hostSafeList: ['dashboard.firm24.com', 'dev.firm24.com'],
    payload: {
        client: {
            javascript: {
                code_version: import.meta.env.VUE_APP_COMMIT_REF,
                source_map_enabled: true,
                guess_uncaught_frames: true,
            },
        },
    },
    transform: function (payload) {
        if (!payload.body || !payload.body.trace || !payload.body.trace.frames) {
            return payload;
        }

        // Filter out third-party script errors
        const isThirdPartyError = payload.body.trace.frames.some((frame) => {
            if (!frame.filename) return true;

            const filename = frame.filename.toLowerCase();
            return (
                filename.includes('hubspot') ||
                filename.includes('hs-analytics') ||
                filename.includes('hs-script') ||
                filename.includes('forms.hscollectedforms.net') ||
                filename.includes('js.hs-scripts') ||
                filename.includes('api.hubapi.com') ||
                filename.includes('cdn.jsdelivr.net') ||
                filename.includes('googletagmanager') ||
                filename.includes('doubleclick.net') ||
                filename.includes('facebook.net') ||
                filename.includes('google-analytics') ||
                filename.includes('linkedin.com') ||
                filename.includes('px.ads.linkedin.com') ||
                filename.includes('forms.hubspot.com') ||
                filename.includes('js.hsforms.net')
            );
        });

        if (isThirdPartyError) {
            return null;
        }

        return payload;
    },
};
